// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Card,
//   CardContent,
//   CardMedia,
//   Typography,
//   IconButton,
// } from "@mui/material";
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

// const ProfileAutoScrollCard = ({ profiles = [] }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   // Auto-scroll effect
//   useEffect(() => {
//     const interval = setInterval(() => {
//       handleNext();
//     }, 3000);
//     return () => clearInterval(interval);
//   }, [profiles.length]);

//   const handleNext = () => {
//     setCurrentIndex((prev) => (prev + 1) % profiles.length);
//   };

//   const handlePrev = () => {
//     setCurrentIndex((prev) =>
//       prev === 0 ? profiles.length - 1 : prev - 1
//     );
//   };

//   const current = profiles[currentIndex];

//   return (
//     <Box
//       sx={{
//         position: "relative",
//         width: {
//           xs: "100%",
//           sm: "350px",
//           md: "380px",
//           lg: "422px",
//           xl: "380px",
//           xxl: "900px",
//         },
//         height: {
//           xs: "auto",
//           sm: "190px",
//           md: "190px",
//           xl: "190px",
//           xxl: "350px",
//         },
//         borderRadius: "32px",
//         display: "flex",
//         // justifyContent: "center",
//         // alignItems: "center",
//         border: "2px solid #c1721f",
//         padding: { xs: "5px" },
//         // marginLeft: {
//         //   sm: "0px",
//         //   md: "10%",
//         //   lg: "10%",
//         //   xl: "10%",
//         //   xxl: "10%",
//         // },
//         // marginRight: { xs: "30px" },
//         // marginBottom: { xs: "60px" },
//         marginTop: "10px",
//         backgroundColor: "#FAF3E0",
//       }}
//     >
//       <IconButton
//         onClick={handlePrev}
//         sx={{ position: "absolute", left: 8, zIndex: 1 }}
//       >
//         <ArrowBackIosIcon />
//       </IconButton>

//       <Card
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           gap: 2,
//           borderRadius: "24px",
//           backgroundColor: "#FFF",
//           padding: 2,
//           width: "100%",
//           maxWidth: "100%",
//         }}
//       >
//         <CardMedia
//           component="img"
//           image={current.image}
//           alt={current.name}
//           sx={{ width: 150, height: 150, borderRadius: "50%" }}
//         />
//         <CardContent>
//           <Typography variant="h6">{current.name}</Typography>
//           <Typography variant="body2">Age: {current.age}</Typography>
//           <Typography variant="body2">Income: {current.income}</Typography>
//         </CardContent>
//       </Card>

//       <IconButton
//         onClick={handleNext}
//         sx={{ position: "absolute", right: 8, zIndex: 1 }}
//       >
//         <ArrowForwardIosIcon />
//       </IconButton>
//     </Box>
//   );
// };

// export default ProfileAutoScrollCard;


import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Fade,
  IconButton
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { matrimoneyEndPoints } from "../../../services/apis";
import axios from "axios";
import { showError, showSuccess } from "./sweetAlert/sweetAlert";
import { useNavigate } from "react-router-dom";
const ProfileAutoScrollCard = ({ profiles = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [show, setShow] = useState(true);
   const navigate = useNavigate(); // Initialize navigate
  let userType = sessionStorage.getItem("userType")
    let token
    if(userType){
      token = sessionStorage.getItem("token");
    }else{
       token = localStorage.getItem("token");
    }
    const profile = localStorage.getItem("profileData");
    const storedProfileData = JSON.parse(profile)
  const loadRazorpay = async (planId) => {
    // Optional: Fetch order from your backend
    const data = await axios.post(matrimoneyEndPoints.CREATE_ORDER, { planId: planId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

    if (data && data?.data && data?.data.status) {
      const options = {
        key: "rzp_test_dxrCt5ZPpT9H0g", // replace with your Razorpay Key ID
        amount: data?.data?.data?.amount, // amount in paise (₹100)
        currency: "INR",
        name: "Annapurna Marriages",
        description: "Plan Subscription",
        order_id: data?.data?.data?.id, // uncomment this if using backend-generated order
        handler: async function (response) {
          try {
            const verifyPayment = await axios.post(
              matrimoneyEndPoints.VERIFY_PAYMENT,
              {
                "razorpay_order_id": response.razorpay_order_id,
                "razorpay_payment_id": response.razorpay_payment_id,
                "razorpay_signature": response.razorpay_signature
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }
            );

            if (verifyPayment.data.status) {
              showSuccess(verifyPayment.data.message)
              navigate("/profile/DetaliesDashbord?type=suggested-profiles");
            } else {
              showError(verifyPayment.data.message)
            }
          } catch (error) {
            console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
          }
          // console.log("Payment ID:", response.razorpay_payment_id);
          // console.log("Order ID:", response.razorpay_order_id);
          // console.log("Signature:", response.razorpay_signature);

        },
        prefill: {
          name: `${storedProfileData?.firstName} ${storedProfileData?.lastName}`,
          email: storedProfileData?.email,
          contact: storedProfileData?.mobile,
        },
        notes: {
          address: "Your Company Address",
        },
        theme: {
          color: "#3399cc",
        },
      };

      // console.log("options..............", options)

      const rzp = new window.Razorpay(options);
      rzp.open();
    } else {
      alert(data?.data?.message)
    }


  };
  useEffect(() => {
    const interval = setInterval(() => {
      setShow(false); 
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % profiles.length);
        setShow(true); 
      }, 500);
    }, 3000);

    return () => clearInterval(interval);
  }, [profiles.length]);

  if (profiles.length === 0) return null;

  const current = profiles[currentIndex];
  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % profiles.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? profiles.length - 1 : prev - 1
    );
  };
  return (
    <Box
      sx={{
        position: "relative",
        width: {
          xs: "100%",
          sm: "350px",
          md: "380px",
          lg: "422px",
          xl: "380px",
          xxl: "900px",
        },
        height: {
          xs: "auto",
          sm: "190px",
          md: "190px",
          xl: "190px",
          xxl: "350px",
        },
        borderRadius: "32px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: "2px solid #c1721f",
        padding: { xs: "5px" },
        marginTop: "10px",
        // backgroundColor: "#FAF3E0",
      }}
    >
      <Fade in={show} timeout={500}>
        <Card
          sx={{
            position: "relative", 
            display: "flex",
            alignItems: "center",
            gap: 2,
            borderRadius: "24px",
            backgroundColor: "#FFF",
            padding: 2,
            width: "100%",
            maxWidth: "100%",
          }}
        >
          <IconButton
            onClick={handlePrev}
            sx={{
              position: "absolute",
              top: 8,
              left: 8,
              zIndex: 1,
               width:"20px",
              height:"20px",
              backgroundColor: "#ffffffaa",
            }}
          >
            <ArrowBackIosIcon sx={{ width:"20px",
              height:"20px",}}
              />
          </IconButton>

          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 1,
               width:"20px",
              height:"20px",
              backgroundColor: "#ffffffaa",
            }}
          >
            <ArrowForwardIosIcon  sx={{ width:"20px",
              height:"20px",}}/>
          </IconButton>
         <CardMedia
  component="img"
  onClick={() => loadRazorpay(current?.planId)}
  image={current?.profileImage}
  alt={current?.name}
  sx={{
    width: 150,
    height: 150,
    borderRadius: "50%",
    objectFit: "cover",
    flexShrink: 0,
    cursor: "pointer",         // good UX for clickable items
    border: "2px solid #ddd",  // optional: adds a clean border
  }}
/>


          <CardContent>
            <Typography variant="h6">{current?.name}</Typography>
            <Typography variant="body2">Age: {current?.age}</Typography>
            <Typography variant="body2">Income: {current?.anualIncome}</Typography>
          </CardContent>
        </Card>
      </Fade>

    </Box>
  );
};

export default ProfileAutoScrollCard;
